export class ThingUiObject {
  accessoryId: string;
  macId: string;
  buildNumber: number;
  accessoryImageUrl: string;
  accessoryDisplayName: string;
  accessoryLocationType: string;
  isNewelyRegistred: boolean;
  isOnline: boolean;
  currentStatus: [string];
  statusTopic: string;
  controlTopic: string;
  eachthingName: string;

  constructor(
    accessoryId: string,
    macId: string,
    buildNumber: number,
    accessoryImageUrl: string,
    accessoryDisplayName: string,
    accessoryLocationType: string,
    isNewelyRegistred: boolean,
    isOnline: boolean,
    currentStatus: [string],
    statusTopic: string,
    controlTopic: string,
    eachthingName: string
  ) {
    this.accessoryId = accessoryId;
    this.buildNumber = buildNumber;
    this.macId = macId;
    this.accessoryImageUrl = accessoryImageUrl;
    this.accessoryDisplayName = accessoryDisplayName;
    this.accessoryLocationType = accessoryLocationType;
    this.isNewelyRegistred = isNewelyRegistred;
    this.isOnline = isOnline;
    this.currentStatus = currentStatus;
    this.statusTopic = statusTopic;
    this.controlTopic = controlTopic;
    this.eachthingName = eachthingName;
  }
}
